import { UserState } from "redux-oidc";

interface IUserService {
  getUtcOffset(userState: UserState): number;
  isUserCadmakers(userState: UserState): boolean;
}

class UserService implements IUserService {
  private readonly utcOffsetKey: string = "utcOffset";

  private readonly companyNameKey: string = "companyName";

  private readonly cadmakersCompanyName: string = "CadMakers";

  getUtcOffset(userState: UserState): number {
    if (userState.user) {
      // get the utc offset claim
      const value = (userState.user.profile as any)[this.utcOffsetKey];
      if (value) {
        return parseInt(value, 10);
      }
      return 0;
    }
    return 0;
  }

  isUserCadmakers(userState: UserState): boolean {
    if (userState.user) {
      const value = (userState.user.profile as any)[this.companyNameKey];
      return value === this.cadmakersCompanyName;
    }
    return false;
  }
}

export const userService: IUserService = new UserService();
